<script lang="ts">
	import Article from '$lib/components/Article.svelte';
	import Page from '$lib/components/Page.svelte';
	import NotFound from '$lib/components/not-found.svelte';

	let { data } = $props();
</script>

{#if !data.pageOrArticle}
	<NotFound />
{:else if data.pageOrArticle.__typename === 'Page'}
	<Page page={data.pageOrArticle} />
{:else if data.pageOrArticle.__typename === 'Article'}
	<Article article={data.pageOrArticle} />
{/if}
